// import { Wrapper } from '../../shared/wrapper';
import { useUnit } from 'effector-react';
import { useTranslations } from 'next-intl';
import ProgramCalculatorV2 from '../../shared/calculator';
import { $calculatorOpenedStore, calculatorStateChanged } from '../../shared/models/calculatorState.store';
// import preview_header_height from '../../webp/preview_height_quality.webp';
import { FC, memo } from 'react';
import ProgressiveImage from 'react-progressive-image';
import { styled } from '../../shared/styles';

let Header: FC<{ className?: string }> = ({ className }) => {
  const isOpened = useUnit($calculatorOpenedStore);
  const handleClickOpen = () => calculatorStateChanged(true);
  const handleDialogClose = () => calculatorStateChanged(false);

  const t = useTranslations();
  // const isMobile = useMediaQuery({ query: '(min-width: 1920px)' });

  return (
    <header className={className}>
      <div className='gradient_block' />
      {/* @ts-ignore */}
      <ProgressiveImage
        src={'/images/webp/main_image.webp'}
        placeholder={'/images/webp/preview_height_quality_small.webp'}
      >
        {(src, loading) => (
          <img
            src={src}
            loading='eager'
            alt='an image'
            className='header_preview header_preview_desktop header_preview_new'
            style={{
              filter: loading ? 'blur(10px)' : 'none',
              transition: 'filter 0.3s ease-out',
              pointerEvents: 'none'
            }}
          />
        )}
      </ProgressiveImage>
      {/* @ts-ignore */}
      <ProgressiveImage src={'/images/webp/main_image.webp'} placeholder={'/images/webp/main_small.webp'}>
        {(src, loading) => (
          <img
            src={src}
            loading='eager'
            alt='an image'
            className='header_preview header_preview_mobile'
            style={{
              filter: loading ? 'blur(10px)' : 'none',
              transition: 'filter 0.3s ease-out'
            }}
          />
        )}
      </ProgressiveImage>
      <div>
        <div className='header_text_block'>
          <h1>
            Magnet <img src={'/images/icons/landing/logo_h_lg.png'} alt='logo' className='logo_img' />
          </h1>
          <ProgramCalculatorV2 onClose={handleDialogClose} open={isOpened} />
          <p>{t('header.previewText')}</p>
          <button onClick={handleClickOpen}>{t('header.calcBtn')}</button>
        </div>
      </div>
    </header>
  );
};

Header = styled(Header, {
  '&': {
    maxWidth: '1710px',
    padding: '0 40px',
    margin: '0 auto',
    position: 'relative',

    minHeight: '764px',

    '@toXL': {
      minHeight: '640px',
      maxWidth: '1225px'
    },
    '@toDesktop': {
      minHeight: '578px'
    },
    '@to992px': {
      minHeight: '440px'
    },
    // '@toTablet': {
    //   minHeight: '421px',
    //   padding: '0 20px 0 20px'
    // },
    '@toTablet': {
      padding: '0 20px',
      minHeight: 'min-content'
    }
  },
  '& .gradient_block': {
    top: 0,
    left: 0,
    position: 'absolute',
    width: '100vw',
    height: '80vh',
    background: 'transparent',
    borderRadius: '20px'
  },
  '& .gradient_block::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
    background: 'radial-gradient(circle, #4d1aba9a 10%, transparent 60%)',
    filter: 'blur(280px)'
  },
  '& .header_text_block': {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '145px',
    zIndex: 1,
    letterSpacing: 0,
    '@toDesktop': {
      marginTop: '95px'
    },
    '@toTablet': {
      marginTop: '-155px'
    },
    '.logo_img': {
      width: '133px',

      '@toXL': {
        width: '100px'
      },
      '@toDesktop': {
        width: '84px'
      },
      '@to576': {
        width: '58px'
      }
    },
    h1: {
      fontSize: '133px',
      lineHeight: '100%',
      fontWeight: 'bold',
      marginLeft: '-9px',
      color: 'white',
      '@toXL': {
        fontSize: '100px'
      },

      '@toDesktop': {
        fontSize: '84px',
        marginLeft: '-7px'
      },

      '@to576': {
        fontSize: '58px',
        marginLeft: '-5px'
      }
    },
    p: {
      marginTop: '24px',
      fontSize: '24px',
      lineHeight: '150%',
      // max-width: 733px,
      maxWidth: '715px',
      color: '#d6d2ea',
      textAlign: 'justify',
      textShadow: '0 2px 2px rgba(0, 0, 0, 1)',
      hyphens: 'auto',
      textJustify: 'inter-word',
      wordBreak: 'break-word',
      '@toXL': {
        fontSize: '18px',
        // maxWidth: 550px,
        maxWidth: '480px'
      },

      '@toDesktop': {
        // maxWidth: 390px,
        maxWidth: '450px'
      },

      '@toTablet': {
        maxWidth: 'max-content'
      }
    },
    button: {
      width: 'fit-content',
      marginTop: '32px',
      padding: '15px 26.5px',
      background: 'linear-gradient(0deg, #1d67b7 0%, #2e4dbf 41%, #5b3d99 59%, #9b3b9b 100%)',
      color: '#ffffff',
      /* Белый цвет текста */
      borderRadius: '100px',
      fontSize: '18px',
      fontWeight: 'medium',
      lineHeight: '160%',
      transition: 'all 0.2s',

      '&:hover': {
        transform: 'scale(1.01)'
      },

      '@toDesktop': {
        padding: '15px 38.5px'
      },

      '@toTablet': {
        width: '100%'
      }
    }
  },
  '& .header_preview': {
    position: 'absolute',
    top: '-115px',
    transform: 'scale(1.3)',
    right: '-108px',
    width: '760px',
    '@toXL': {
      transform: 'scale(1.154)',
      top: '-100px'
    },
    '@toDesktop': {
      width: '700px',
      right: '-130px'
    },
    '@to992px': {
      // transform: scale(1.2),
      width: '568px',
      top: '-175px',
      right: '-100px'
      // height: 548px,
    },

    '@toTablet': {
      right: '-100px',
      top: '-115px',
      transform: 'scale(1.1)'
      // top: 0,
    },
    '@to576': {
      right: '-100px',
      top: '-100px',
      transform: 'scale(1.1)'
      // top: 0,
    }
  },
  '& .header_preview_new': {
    '@from1920': {
      width: '700px',
      height: '732px'
    }
  },
  '& .header_preview_desktop': {
    display: 'block',

    '@toTablet': {
      display: 'none'
    }
  },
  '& .header_preview_mobile': {
    display: 'none',

    '@toTablet': {
      marginTop: '70px',
      display: 'block',
      position: 'relative',
      width: '430px',
      height: '447px',
      left: '65%',
      transform: 'translateX(-50%)'
    }
  }
});

export default memo(Header);
{
  /* <ProgressiveImage src={preview_header_height} placeholder={preview_header_height_small}>
          {(src, loading) => (
            <img
              src={src}
              loading='eager'
              alt='an image'
              className='header_preview header_preview_desktop'
              style={{
                filter: loading ? 'blur(10px)' : 'none',
                transition: 'filter 0.3s ease-out',
                pointerEvents: 'none'
              }}
            />
          )}
        </ProgressiveImage>{' '} */
}
